import { IS_MOBILE } from 'constants/responsive';

export const getItemTopPositionDesktop = (index: number): string => {
    if (index > 2 && index < 6) {
        return '30px';
    }

    if (index > 5) {
        return '60px';
    }

    return '0px';
};

export const getItemTopPosition = (index: number): string => {
    const mobileHeaderHeight = '77px';
    const mobileTopStep = '25px';
    const desktopHeaderHeight = '87px';

    return IS_MOBILE
        ? `calc((${index} * ${mobileTopStep}) + ${mobileHeaderHeight})`
        : `calc((${getItemTopPositionDesktop(index)}) + ${desktopHeaderHeight})`;
};
